/* eslint-disable no-undef */
// project imports
import services from 'utils/mockAdapter';
// import { processEm } from 'data/e-commerce';
import processEm from 'data/processEm.json';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/processEm/list').reply(200, { processEm });

services.onPost('/api/processEm/filter').reply((config) => {
  try {
    const { filter } = JSON.parse(config.data);

    if (filter.sort === 'high') {
      processEm.sort((a, b) => Number(b.amount) - Number(a.amount));
    }

    if (filter.sort === 'low') {
      processEm.sort((a, b) => Number(a.amount) - Number(b.amount));
    }

    // if (filter.sort === 'popularity') {
    //   processEm.sort((a, b) => Number(b.popularity) - Number(a.popularity));
    // }

    // if (filter.sort === 'stock') {
    //   processEm.sort((a, b) => Number(b.stock) - Number(a.stock));
    // }

    // if (filter.sort === 'new') {
    //   processEm.sort((a, b) => Number(b.new) - Number(a.new));
    // }

    const results = processEm.filter((processEm) => {
      let searchMatches = true;

      if (filter.search) {
        const properties = ['name', 'process', 'ratio', 'classification', 'unit', 'amount'];
        let containsQuery = false;

        properties.forEach((property) => {
          if (processEm[property] && processEm[property].toString().toLowerCase().includes(filter.search.toString().toLowerCase())) {
            containsQuery = true;
          }
        });

        if (!containsQuery) {
          searchMatches = false;
        }
      }

      // const genderMatches = filter.gender.length > 0 ? filter.gender.some((item) => item === processEm.gender) : true;
      // const categoriesMatches =
      //   filter.categories.length > 0 && filter.categories.some((category) => category !== 'all')
      //     ? filter.categories.some((category) => processEm.categories.some((item) => item === category))
      //     : true;
      // const colorsMatches = filter.colors.length > 0 ? filter.colors.some((color) => processEm.colors.some((item) => item === color)) : true;

      // const minMax = filter.price ? filter.price.split('-') : '';
      // const priceMatches = filter.price ? processEm.amount >= minMax[0] && processEm.amount <= minMax[1] : true;
      // const ratingMatches = filter.rating > 0 ? processEm.rating >= filter.rating : true;

      return searchMatches;
    });

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/processEm/details').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    let results;
    if (id === 'default') {
      [results] = processEm;
    } else {
      // eslint-disable-next-line
      [results] = processEm?.filter((processEm) => processEm.id === Number(id));
    }

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/processEm/related').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    const results = processEm.filter((processEm) => processEm.id !== Number(id));

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/processEm/list/single').reply((config) => {
  try {
    const result = processEm.find((e) => e.id === Number(config.data));
    return [200, result];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/processEm/insert').reply((config) => {
  try {
    let list = JSON.parse(config.data);
    list = {
      ...list,
      id: processEm.length + 1
    };
    processEm.push(list);
    return [200, { list }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/processEm/update').reply((config) => {
  try {
    const list = JSON.parse(config.data);

    let NewProduct = null;
    _.map(processEm, (_list) => {
      if (_list.id === list.id) {
        _.assign(_list, { ...list });
        NewProduct = _list;
      }
      return _list;
    });

    return [200, { NewProduct }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
